/** ***** 验证规则对象 *******/
const rulesMap = {
  /** ******** 用户名验证 ***********/
  validUsername: (rule, value, callback) => {
    if (!rule.required && (value === undefined || value === '')) {
      callback()
    }
    if (!value.replace(/\s*/g, '').length > 0) {
      callback(new Error(rule.message ? rule.message : '请输入正确的用户名!'))
    } else {
      callback()
    }
  },
  /** ******** 邮箱验证 ***********/
  validEmail: (rule, value, callback) => {
    if (!rule.required && (value === undefined || value === '')) {
      callback()
    }
    const  reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
    if (!reg.test(value)) {
      callback(new Error(rule.message ? rule.message : '请输入正确的邮箱!'))
    } else {
      callback()
    }
  },
  /** ******** 密码验证 ***********/
  isPassWord: (rule, value, callback) => {
    if (!rule.required && (value === undefined || value === '')) {
      callback()
    }
    const reg = /^[0-9a-zA-Z~!@#$%^&*()_+,.;']{6,20}$/
    if (!reg.test(value)) {
      callback(new Error(rule.message ? rule.message : '6-20位数字/字符/字母的组合；可以为纯数字，纯字符，纯字母!'))
    } else {
      callback()
    }
  },
  /** ******** 手机号验证 ***********/
  isPhone: (rule, value, callback) => {
    if (!rule.required && (value === undefined || value === '')) {
      callback()
    }
    if (!rule.required && (value === undefined || value === '')) {
      callback()
    }
    const reg = /^((0\d{2,3}-\d{7,8})|(1[1234567890]\d{9}))$/
    if (!reg.test(value)) {
      callback(new Error(rule.message ? rule.message : '请输入正确的手机号!'))
    } else {
      callback()
    }
  },
  /** ******** 身份证验证 ***********/
  isID: (rule, value, callback) => {
    if (!rule.required && (value === undefined || value === '')) {
      callback()
    }
    const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
    if (!reg.test(value)) {
      callback(new Error(rule.message ? rule.message : '请输入正确的身份证号码!'))
    } else {
      callback()
    }
  },
  /** ******** 整数验证 ***********/
  isNum: (rule, value, callback) => {
    if (!rule.required && (value === undefined || value === '')) {
      callback()
    }
    const reg = /^\+?[1-9][0-9]*$/
    if (!reg.test(value)) {
      callback(new Error(rule.message ? rule.message : '请输入正确的数字!'))
    } else {
      console.log(rule.maxN)
      if (rule.maxN && rule.maxN < value) {
        rule.message = '输入的数需要小于'+rule.maxN+'!'
        callback(new Error(rule.message ? rule.message : '请输入正确的数字!'))
      } else {
        callback()
      }
    }
  },
  /** ******** 小数验证 ***********/
  isFloat: (rule, value, callback) => {
    if (!rule.required && (value === undefined || value === '')) {
      callback()
    }
    const reg = /(^[+]?((0|([1-9]\d*))\.?\d{0,2})?$)/
    if (!reg.test(value) || value === undefined || value === '' || value === 0) {
      callback(new Error(rule.message ? rule.message : '请输入正确数字!'))
    } else {
      callback()
    }
  },
  /** ******** 非空验证 ***********/
  isNotEmptyStringNull: (rule, value, callback) => {
    if (!value.replace(/\s+/g, '').length > 0) {
      callback(new Error(rule.message ? rule.message : '该选项不能为空!'))
    } else {
      callback()
    }
  },
  /** ******** 非空验证1 ***********/
  isNotEmpty: (rule, value, callback) => {
    if (value) {
      let val = value.toString()
      if (!val.length > 0) {
        callback(new Error(rule.message ? rule.message : '该选项不能为空!'))
      } else {
        callback()
      }
    } else {
      callback(new Error(rule.message ? rule.message : '该选项不能为空!'))
    }
  },

  /** ******** 密码重复验证 ***********/
  repeatPassWord: (rule, value, callback) => {
    if (!rule.required && (value === undefined || value === '')) {
      callback()
    }
    if (!rule.required && (value === undefined || value === '')) {
      callback()
    }
    if (value !== rule.formData[rule.isAgain]) {
      callback(new Error(rule.message ? rule.message : '请输入!'))
    } else {
      callback()
    }
  }
}

/** **** 表单验证对象 *******/
let rulesList = {}
/** **********  调用方法传入需要验证的数组对象 ***************/
export function chagenRules (e, formData) {
  rulesList = {}
  for (let a of e) {
    rulesList[a.name] = [
      {required: a.required ? a.required : false, validator: rulesMap[a.vName], trigger: 'change', message: a.msg ? a.msg : undefined, formData: formData, isAgain: a.againName,maxN: a.maxN}
    ]
  }
  return rulesList
}
export default rulesList

export function rulesValidate (el, $confirm, backFu) {
  el.validate((valid) => {
    if (valid) {
      backFu()
    } else {
      console.log(el)
      $confirm('必填项不能为空！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {}).catch(() => { })
      return false
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/validateTool.js